module.exports = __webpack_public_path__ + "img/wk2.cfb12dae.jpg";